import { Component } from './Dialog.component'
import { ContextProvider, useDialog } from './Dialog.context'

export const Dialog = {
  Component: Component,
  Hook: useDialog,
  Provider: ContextProvider,
}
